<div class="container-fluid">
  <h3>
    {{ 'events.settings.general.component.title' | translate }}
    <span>
      <a href="https://support.weblinkinternational.com/hc/en-us/articles/235637748-Event-Settings-General-Settings" target="_blank">
        <img
          src="/assets/img/help.png"
          title="{{ 'events.settings.general.component.general-title-help' | translate }}"
          class="wc-help-icon"
        />
      </a>
    </span>
  </h3>
  <div class="form-horizontal">
    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-name-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <input type="text" class="form-control" [(ngModel)]="event.EventName" />
      </div>
    </div>

    <div>
      <div class="form-group">
        <label class="control-label col-sm-3 col-lg-2">
          {{
            !showStartEndTime
              ? ('events.settings.general.component.event-start-date-label' | translate)
              : ('events.settings.general.component.event-start-date-and-time-label' | translate)
          }}
        </label>
        <div class="col-sm-2">
          <wl-date-selector name="startDate" (onDateChanged)="startDateChanged($event)" [(ngModel)]="event.StartDate"> </wl-date-selector>
        </div>
        <div class="col-sm-2" *ngIf="showStartEndTime">
          <wl-time-selector inputCssClass="form-control" name="startTime" [(ngModel)]="event.StartTime"></wl-time-selector>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label col-sm-3 col-lg-2">
          {{
            !showStartEndTime
              ? ('events.settings.general.component.event-end-date-label' | translate)
              : ('events.settings.general.component.event-end-date-and-time-label' | translate)
          }}
        </label>
        <div class="col-sm-2">
          <wl-date-selector
            name="endDate"
            [(ngModel)]="event.EndDate"
            [minDate]="event.StartDate"
            (onDateChanged)="endDateChanged()"
          ></wl-date-selector>
        </div>
        <div class="col-sm-2" *ngIf="showStartEndTime">
          <wl-time-selector inputCssClass="form-control" name="endTime" [(ngModel)]="event.EndTime"></wl-time-selector>
        </div>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-2"></div>
      <div class="col-sm-4">
        <p-checkbox name="isAllDay" [(ngModel)]="event.IsAllDay" [binary]="true" inputId="isAllDay" (onChange)="allDayChanged($event)">
        </p-checkbox>
        <label for="isAllDay">
          {{ 'events.settings.general.component.event-all-day' | translate }}
        </label>
      </div>
    </div>

    <div class="form-group" *ngIf="showSeparateHoursCheckbox">
      <div class="col-sm-2"></div>
      <div class="col-sm-4">
        <p-checkbox
          name="chkSetSeparateHours"
          [(ngModel)]="event.DisplaySeparateHours"
          [binary]="true"
          inputId="chkSetSeparateHours"
          (onChange)="setHoursSeparatelyChanged($event)"
        >
        </p-checkbox>
        <label for="chkSetSeparateHours">
          {{ 'events.settings.general.component.event-separate-hours-label' | translate }}
        </label>
      </div>
    </div>

    <div *ngIf="event.DisplaySeparateHours">
      <div class="col-sm-2"></div>
      <div class="col-sm-10 pl-5">
        <wl-events-v4-event-dates-edit [eventDateTimes]="event.EventDateTimes"></wl-events-v4-event-dates-edit>
      </div>
    </div>

    <div class="form-group" *ngIf="!event.IsAllDay">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.time-zone-label' | translate | titlecase }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <div class="input-group">
          <wl-time-zone-selector [(ngModel)]="event.TimeZoneId"></wl-time-zone-selector>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-image-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <wl-image-lookup
          name="image"
          [(ngModel)]="event.ImageUrl"
          (onImageChanged)="eventImageChanged($event)"
          [helpIconTitle]="'events.settings.general.component.image-upload-help' | translate"
        ></wl-image-lookup>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-type-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <select class="form-control" [(ngModel)]="event.EventType">
          <option *ngFor="let eventType of eventTypes" [value]="eventType" [selected]="eventType == event.EventType ? true : null">
            {{ eventType }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-calendar-type-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <ul class="list-inline stack-mobile">
          <li>
            <label
              ><input type="checkbox" [(ngModel)]="event.OrgEvent" />
              {{ 'events.settings.general.component.event-organizational-label' | translate }}</label
            >
          </li>
          <li>
            <label
              ><input type="checkbox" [(ngModel)]="event.IsPublic" />
              {{ 'events.settings.general.component.event-community-label' | translate }}</label
            >
          </li>
          <li>
            <label
              ><input type="checkbox" [(ngModel)]="event.MembersOnly" />
              {{ 'events.settings.general.component.event-members-only-label' | translate }}</label
            >
          </li>
          <li>
            <label
              ><input type="checkbox" [(ngModel)]="event.Internal" />
              {{ 'events.settings.general.component.event-internal-label' | translate }}</label
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-offset-3 col-lg-offset-2 col-sm-9 col-lg-10">
        <label
          ><input type="checkbox" [(ngModel)]="event.FeaturedEvent" />
          {{ 'events.settings.general.component.event-featured-event-label' | translate }}</label
        >
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-location-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <wl-profile-selector
          name="profileOrgLookup"
          [(ngModel)]="event.ProfileId"
          (onProfileChanged)="eventProfileChanged($event)"
        ></wl-profile-selector>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-venue-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <input type="text" class="form-control" [(ngModel)]="event.Venue" />
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-address-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <div class="form-group">
          <div class="col-sm-12">
            <input type="text" class="form-control" [(ngModel)]="event.Address1" />
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <input type="text" class="form-control" [(ngModel)]="event.Address2" />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label class="col-sm-12">
                {{ 'events.settings.general.component.event-city-label' | translate }}
              </label>
              <div class="col-sm-12">
                <input type="text" class="form-control" [(ngModel)]="event.City" />
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="form-group">
              <label class="col-sm-12">
                {{ 'events.settings.general.component.event-state-province-label' | translate }}
              </label>
              <div class="col-sm-12">
                <wl-state-selector name="eventState" [displayAbbreviation]="true" [(ngModel)]="event.State"></wl-state-selector>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-12">
                {{ 'events.settings.general.component.event-postal-code-label' | translate }}
              </label>
              <div class="col-sm-12">
                <input type="text" class="form-control" [(ngModel)]="event.Zip" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-directions-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <textarea class="form-control" [(ngModel)]="event.Location"></textarea>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-short-description-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <textarea class="form-control" [(ngModel)]="event.ShortDescr"></textarea>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-instructor-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <input type="text" class="form-control" [(ngModel)]="event.Instructor" />
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-coursenum-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10">
        <input type="text" class="form-control" [(ngModel)]="event.CourseNum" />
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3 col-lg-2">
        {{ 'events.settings.general.component.event-long-description-label' | translate }}
      </label>
      <div class="col-sm-9 col-lg-10" *ngIf="showEditor">
        <wl-wysiwyg-editor [(ngModel)]="event.Descr" name="descrEditor" [editorName]="'descrEditor'"></wl-wysiwyg-editor>
      </div>
    </div>
  </div>

<app-back-to-top></app-back-to-top>
</div>
